export default {"src":"/_next/static/media/cart-bold-grey.6d9f4b84.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};